export default function (durationInMs) {
  var dms = parseInt(durationInMs, 10)
  var secNum = Math.ceil(dms / 1000)
  var hours = Math.floor(secNum / 3600)
  var minutes = Math.floor((secNum - (hours * 3600)) / 60)

  if (hours < 10) { hours = '0' + hours }
  if (minutes < 10) { minutes = '0' + minutes }
  return hours + 'H' + minutes
}



// WEBPACK FOOTER //
// ./src/utils/durationFormatter.js